//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'GroupPurchaseBulletScreen',
  props: {
    relationGroupPurchaseVO: {
      type: Object,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var textArr = this.relationGroupPurchaseVO.showText.split(',') || [];
    var textIndex = 0;
    return {
      textIndex: textIndex,
      textArr: textArr,
      showAnimation: false
    };
  },
  computed: {},
  mounted: function mounted() {
    var _this = this;
    this.firstTimer = setTimeout(function () {
      _this.showAimation();
    }, 1000);
  },
  watch: {},
  methods: {
    showAimation: function showAimation() {
      this.showAnimation = true;
    },
    transitioncancel: function transitioncancel() {
      this.handleTransitionEnd();
    },
    handleTransitionEnd: function handleTransitionEnd() {
      var _this2 = this;
      if (this.firstTimer) {
        clearTimeout(this.firstTimer);
      }
      if (this.secondTimer) {
        clearTimeout(this.secondTimer);
      }
      // 过渡动画结束后，将show设置为false，即瞬间返回原位
      this.showAnimation = false;
      this.secondTimer = setTimeout(function () {
        _this2.showAnimation = true;
        _this2.textIndex = (_this2.textIndex + 1) % _this2.textArr.length;
      }, 3000);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.firstTimer) {
      clearTimeout(this.firstTimer);
    }
    if (this.secondTimer) {
      clearTimeout(this.secondTimer);
    }
  }
};